<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/xmxx/xmxx.jpg" class="steps step1" v-if="status=='1'">
            <div class="stepbtn" @click="nextStep(status)">
                {{status=='1'?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <div class="h-crumbOut">
            <div class="h-crumbs">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/xiangmu/pm">项目管理</a></el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/xiangmu/Pdetails">项目信息</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="bigDiv">
            <div class="h-piece">
                <div class="top">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                        <h1>项目信息</h1>
                        <img v-if="formLabelAlign.isSuccess=='0' && projectType=='3'"
                             src="../../../assets/images/pimg/wei.jpg"
                             style="position:absolute;top:0.68rem;right: 1rem;">
                        <img v-if="formLabelAlign.isSuccess=='1' && projectType=='3'"
                             src="../../../assets/images/pimg/zhongbiao.jpg"
                             style="position:absolute;top:0.68rem;right: 1rem;">
                    </div>
                    <div class="pieceCon ccc">
                        <div class="h-pieceCon2">
                            <div class="j_one">
                                <el-form :model="formLabelAlign" label-position="right" :rules="rules"
                                         ref="formLabelAlign1" :inline="true" class="demo-ruleForm h-formbLine">
                                    <el-form-item label="项目名称" class="h-elformWrap-1" prop="projectName">
                                        <el-input v-model="formLabelAlign.projectName" class="h-input"></el-input>
                                    </el-form-item>
                                    <el-form-item label="项目说明" class="h-elformWrap-1" prop="projectDescription">
                                        <el-input v-model="formLabelAlign.projectDescription"
                                                  style=" padding-bottom:13px;" placeholder="请输入项目说明"></el-input>
                                    </el-form-item>
                                    <el-form-item label="招标项目" class="h-elformWrap-1" prop="proName" v-if="projectType=='5'">
                                        <el-select v-model="formLabelAlign.proId" remote
                                                   filterable :filter-method="getTenderList" :v="formLabelAlign.proId" @change="getTenderDetailList" clearable filterable placeholder="请输入"
                                                   :remote-method="getTenderList" >
                                            <el-option v-for="(item) in proList"
                                                       :key="item.id"
                                                       :label="item.proName"
                                                       :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 采购项目使用产品信息 -->
                <div class="n-hu ljjtablepaddings9" v-if="projectType=='5'">
                    <div class="h-pieceTitle2">
                        <h1>产品信息</h1>
                    </div>
                    <div class="yxtable" style="padding-left: 0.15rem;">
                        <el-table
                                :data="proProduct"
                                :border="true">
                            <!--<el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="type"
                                    label="产品大类">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.type"
                                               placeholder="&#45;&#45;请选择&#45;&#45;"
                                               @change="changeBigCg(scope.row)">
                                        <el-option
                                                v-for="(item,index) in optionsProduct1"
                                                :key="index"
                                                :label="item.levelname"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="productName"
                                    label="产品型号">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.productName"
                                               placeholder="&#45;&#45;请选择&#45;&#45;"
                                               filterable
                                               allow-create
                                               default-first-option
                                               @change="optionsProduct2Cg(scope.row)"
                                               style="vertical-align:bottom"
                                    >
                                        <el-option
                                                v-for="(item,index2) in scope.row.optionsProductCg"
                                                :key="index2"
                                                :label="item.levelname"
                                                :value="item.levelname">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="xuniFlag"
                                    label="产品类型">
                                <template scope="scope">
                                    {{scope.row.xuniFlag|dictname('xuni_flag')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="productId"
                                    label="产品编码">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.productId"
                                              class="h-tableInput"
                                              disabled
                                              style="vertical-align:bottom">

                                    </el-input>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="productNum"
                                    label="产品数量">
                                <template scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.productNum"
                                              placeholder="请填写产品数量"></el-input>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="productDes"
                                    label="产品描述"
                                    min-width="150">
                                <template scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.productDes"
                                              placeholder="请填写产品描述"></el-input>
                                </template>
                            </el-table-column>-->

                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="typeName"
                                    label="产品大类"
                                    :show-overflow-tooltip="true"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="productName"
                                    label="产品型号"
                                    :show-overflow-tooltip="true"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="xuniFlag"
                                    label="产品类型"
                                    width="110">
                                <template scope="scope">
                                    <span v-if="scope.row.xuniFlag == 1">虚拟物料</span>
                                    <span v-if="scope.row.xuniFlag == 0">真实物料</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="productId"
                                    label="产品编码"
                                    :show-overflow-tooltip="true"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="productNum"
                                    label="产品数量"
                                    :show-overflow-tooltip="true"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="productPrice"
                                    label="价格"
                                    :show-overflow-tooltip="true"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    :show-overflow-tooltip="true"
                                    width="90">
                            </el-table-column>
                            <el-table-column
                                    prop="shuilv"
                                    label="税率"
                                    :show-overflow-tooltip="true"
                                    width="90">
                            </el-table-column>
                            <el-table-column
                                    prop="supplierCode"
                                    label="供应商编码"
                                    :show-overflow-tooltip="true"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="supplierName"
                                    label="供应商名称"
                                    :show-overflow-tooltip="true"
                                    width="140">
                            </el-table-column>

<!--                            <el-table-column
                                    width="100"
                                    label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delIndex(scope.$index)">删除</el-button>
                                    &lt;!&ndash; <div class="l-operationBox">
                                        <span class="l-operationlist br-operation-delete" title="删除该条" @click="delIndex(scope.$index)"></span>
                                    </div> &ndash;&gt;
                                </template>
                            </el-table-column>-->
                        </el-table>
<!--
                        <div class="h-tableAdd" @click="addCG">
                            <a>新增一行</a>
                        </div>
-->

                    </div>
                </div>
                <!-- 采购项目使用产品信息 -->
                <div class="h-txtCenter h-mrt60">
                    <el-button class="el-button h-btn h-bBtn el-button--default"
                               :class="projectType=='5'&&whflag?'h-bgwhite':'h-bgblueQ2'" @click="cancelPro">返回
                    </el-button>
                    <el-button v-if="projectType=='5'&&shflag"
                               class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="submitPro()">重新提交
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                optionsProductCg: {},
                xmguanliyuan: false,
                tejiaflag: '',
                showOrhide: false,
                status: 1,
                checked: true,
                toshow: "Pdetails7",
                showtime: false,
                times: [],
                shflag: false,
                whflag: false,
                optionsAgent: [],
                agent: [{agentCode: ''}],
                agent2: [],
                proProductwx: {productPrice: '', type: '', productId: ''},
                projectType: 3,
                proBidInfo: {},
                formInline: {},
                formLabelAlign: {
                    type: 3,
                    isSuccess: "2",
                    proBidInfoList: [],
                    proId: '',
                    tenderId: '',
                    proName:'',
                },
                optionsCustomer: [],
                //产品信息
                proProduct: [],
                //产品大类选项
                optionsProduct1: [],
                //产品小类选项
                optionsProduct2: [],
                optionsArea: [],
                customeInfo: {},
                projectId: '',
                //竞品使用
                //带线表单
                categorys: '海尔产品',
                category: ['海尔产品', '竞品'],
                //附件类别
                jingpinOther: "竞品信息-其他品牌",
                jingpinHaier: "竞品信息-海尔",
                wxpo: "外销项目-PO",
                wxpi: "外销项目-PI",
                zhxm: "展会项目-资料",
                //产品大类选项
                optionsProductBig: [],
                //产品小类选项
                optionsProductHaier: [{}],
                //海尔产品竞品
                productInfosHaier: "",
                //其他品牌产品竞品
                productInfosOther: "",
                proBidInfoList1: [{
                    bidTotal: '',
                    contractCode: '',
                    otherBrand: '',
                    otherModel: '',
                    otherComp: '',
                    otherTotal: '',
                    fujian: ''
                }],
                rules: {},
                proList:[],
            }
        },
        mounted() {
            // this.selectCustomer();
            this.selectProduct1();
            this.selectBidInfo();
            this.query();
            //竞品使用
            this.selectProductBig();

            // swyl_xiangmgly ：内销项目管理员
            this.xmguanliyuan = this.$store.getters.hasRole('swyl_admin,swyl_xiangmgly');

        },
        created() {
            this.showzhezhao()
        },
        methods: {
            submitPro() {
                var subflag1 = false;
                var subflag3 = true;
                this.$refs['formLabelAlign1'].validate((valid) => {
                    if (valid) {
                        subflag1 = true;
                    } else {
                        this.$msg.msge("请完善项目信息后再提交！");
                        return false;
                    }
                });
                this.proProduct.forEach((item, index) => {
                        if (!(item.productId || item.productName) || !item.type || !item.productNum) {
                            subflag3 = false;
                            return false;
                        }
                })
                if (!subflag3) {
                    this.$msg.msge("请完善表格中的产品信息后再提交！");
                }
                if (subflag1  && subflag3) {
                    this.formLabelAlign.proProductInfoList = this.proProduct
                    console.log('产品详情121', this.formLabelAlign);

                    this.$msg.confirm("确认提交项目信息?", () => {

                        ss.ProService.savePro(this.formLabelAlign).then(rd => {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("/xiangmu/pm");
                        })
                    })
                }
            },
            //产品型号名称保存
            optionsProduct2Cg(v) {
                if (v.optionsProductCg && v.optionsProductCg.length > 0) {
                    var abb = 0;
                    for (var i = 0; i < v.optionsProductCg.length; i++) {
                        if (v.productName == v.optionsProductCg[i].levelname) {
                            v.productId = v.optionsProductCg[i].id
                            abb++;
                        }
                    }
                }
                if (abb == 1) {
                    v.xuniFlag = 0
                } else {
                    v.xuniFlag = 1
                    v.productId = ''
                }
            },
            //大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProduct2Cg(v) {
                ss.ProService.product2OemSelect(v.type).then(rd => {
                    v.optionsProductCg = rd;
                    //this.$set(this.optionsProduct2,i,rd);
                })
            },
            //大类修改时，当块数据proProduct[i]-v,index-i
            changeBigCg(v) {
                v.xuniFlag = '';
                var sup = _.filter(this.optionsProduct1, {'id': v.type});
                v.typeName = sup[0].levelname;
                this.selectProduct2Cg(v);
            },
            //增加一行采购项目产品
            addCG() {
                var product = {};
                product.productName = '';
                product.type = '';
                product.productNum = '';
                product.productId = '';
                product.productDes = '';
                product.xuniFlag = '';
                product.optionsProductCg = [];
                this.proProduct.push(product);
            },
            showzhezhao() {
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if (rd == false) {
                        this.showOrhide = false;
                    } else {
                        this.showOrhide = true;
                    }
                })
            },
            submitAgent() {
                if (this.agent && this.agent.length > 0 && this.agent[0].agentCode) {
                    this.formLabelAlign.proExhibitionAgentList = this.agent;
                    console.log(this.formLabelAlign, "提交经销商");
                    ss.ProService.saveExhibitionAgent(this.formLabelAlign).then(rd => {
                        this.$msg.msgs("提交成功");
                        this.$router.push("/xiangmu/pm");
                    })
                } else {
                    this.$msg.msge("请选择经销商");
                }
            },
            selectBidInfo() {
                //内销查询中标信息
                if (this.$route.query.protype == '3') {
                    ss.ProService.bidInfo(this.$route.query.id).then(rd => {
                        console.log("内销查询中标信息", rd)
                        if (rd && rd.length > 0) {
                            this.proBidInfo = rd[0];
                        }
                    })
                }
            },
            delIndex(index) {
                this.agent.splice(index, 1);
                this.agent2.splice(index, 1);
                //console.log(index,"删除一行数据");
            },
            agentOptions() {
                //查询经销商客户信息
                ss.UserCare.agentOptionPm({}).then(rd => {
                    console.log("查询经销商信息", rd)
                    this.optionsAgent = rd;
                })
            },
            changeAgent(v, i) {
                this.agent2.splice(i, 1);
                if (_.find(this.agent2, {agentCode: v.agentCode})) {
                    this.$msg.msge("该经销商已选择,请勿重复选择!")
                    v.agentCode = "";
                    return;
                } else {
                    //获取名字
                    var sup = _.filter(this.optionsAgent, {'userCode': v.agentCode});
                    v.agentName = sup[0].userName;
                    this.agent2.push(v);
                    //console.log("sd",v,i);
                }

            },
            //增加海尔产品方法
            //增加产品方法
            adds() {
                var a = {agentCode: ''}
                this.agent.push(a)
                console.log(this.agent);
            },
            /*selectCustomer() {
                ss.ProService.customerSelect().then(rd => {
                    // console.log("客户名称下拉", rd)
                    this.optionsCustomer = rd;
                })
            },*/
            selectProduct1() {
                ss.ProService.product1Select().then(rd => {
                    // console.log("产品大类下拉", rd)
                    this.optionsProduct1 = rd;
                })
            },
            //大类修改时，当块数据proProduct[i]-v,index-i
            changeBig(v, i) {
                v.productId = '';
                v.productPrice = '';
                //console.log("选中大类v.productId222",v,i);
                this.selectProduct2(v.type, i);
            },
            //大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProduct2(v, i) {
                //console.log("3选中大类222",v,i);
                ss.ProService.product2Select(v).then(rd => {
                    //console.log("4产品小类下拉", rd)
                    //console.log("40产品小类下拉", this.optionsProduct2[i])
                    this.optionsProduct2[i] = rd;
                    this.$set(this.optionsProduct2, i, rd);
                    //console.log(this.optionsProduct2[i],"5产品小类下拉", this.optionsProduct2)
                })
            },
            //小类修改，当块数据proProduct[i]-v
            changeSmail(v) {
                //this.$set(v,"productId",v.productId)
                //v.productId=v.productId;
                var data = {
                    mdmMaterialInfoPrice: {
                        materialid: v.productId,
                        leltypecode: 1,
                        type: "03",
                        currency: "CNY"
                    }
                }
                console.log("选中信息2", data)
                ss.ProService.product2Detail(data).then(rd => {
                    console.log("选中信息1", 12)
                    if (rd.obj && rd.obj.length > 0) {
                        console.log("1产品小类详情", rd);
                        v.productPrice = rd.obj[0].mdmMaterialInfoPrice.value;
                    } else {
                        //console.log("22产品小类详情", rd);
                        v.productPrice = null;
                    }
                })
            },
            changeCustomer(c) {
                console.log("选中信息2", c)
                this.optionsCustomer.forEach((item, index) => {
                    if (c == item.userCode) {
                        console.log("选中信息2", item)
                        this.formLabelAlign.customerId = item.userCode;
                        this.formLabelAlign.customerName = item.userName;
                        this.formLabelAlign.keyPerson = item.contactuserName;
                        this.formLabelAlign.keyPersonTel = item.telephone;
                        this.formLabelAlign.customerDept = item.department;
                        this.formLabelAlign.projectArea = this.$getDictName("YLRegion", item.areaCode);
                        this.formLabelAlign.customerChannel = this.$getDictName("sales_region", item.channelCode);
                        if (item.userType && item.userType == '1') {
                            this.formLabelAlign.userType = 1
                        } else {
                            this.formLabelAlign.userType = 2
                        }
                    }
                })
            },
            //查看详情
            query() {
                console.log("sdfsdfsdfsdf");
                var id = this.$route.query.ywid ? this.$route.query.ywid : this.$route.query.id;
                console.log(id);
                if (this.$route.query.ywid && this.$route.query.taskstatus == '0') {
                    this.shflag = true;
                }
                if (this.$route.query.whflag == '1') {
                    this.whflag = true;
                    //加载带选择的经销商
                    this.agentOptions();
                }
                ss.ProService.proDetail(id).then(rd => {
                    console.log(rd, "项目列表");
                    console.log(this.proBidInfo);

                    this.formLabelAlign = rd;
                    this.formLabelAlign.proName = rd.tenderName;
                    this.formLabelAlign.proId = rd.tenderName;
                    if (rd.proBidInfoList != null && rd.proBidInfoList.length > 0) {
                        this.proBidInfoList1 = rd.proBidInfoList;
                    }
                    console.log(this.proBidInfoList1, 'heihei');
                    // this.formLabelAlign.customerChannel=this.$getDictName("sales_region", rd.customerChannel);
                    // this.formLabelAlign.projectArea=this.$getDictName("YLRegion", rd.projectArea);

                    //项目类型赋值
                    this.projectType = this.formLabelAlign.type;
                    this.tejiaflag = this.formLabelAlign.tejiaflag || '';
                    if (this.projectType == '1') {
                        //如果是展会项目类型
                        this.proProduct = rd.proProductInfoList;
                        this.times = rd.times;
                        if (this.formLabelAlign.checkMsg) {
                            this.formLabelAlign.checkMsg = "";
                        }

                        if (rd.proExhibitionAgentList && rd.proExhibitionAgentList.length > 0) {
                            this.agent = rd.proExhibitionAgentList;
                        }
                    } else {
                        //客户信息赋值
                        this.changeCustomer(this.formLabelAlign.customerId);
                        this.proProduct = rd.proProductInfoList;

                        this.proProductwx = rd.proProductInfoList;
                        console.log('采购项目', this.proProductwx);
                        if (rd.userProductInfoHaierList && rd.userProductInfoHaierList.length > 0) {
                            this.productInfosHaier = rd.userProductInfoHaierList;
                        }
                        if (rd.userProductInfoOtherList && rd.userProductInfoOtherList.length > 0) {
                            this.productInfosOther = rd.userProductInfoOtherList;
                        }
                    }
                });
            },
            //项目审核
            usercheck(x) {
                this.formLabelAlign.taskid = this.$route.query.taskid;
                this.formLabelAlign.status = x;
                ss.ProService.checkExpoxm(this.formLabelAlign).then(rd => {
                    this.$store.dispatch('searchTasktotal');
                    this.$msg.alerts("提交成功！", () => {
                        this.$router.push({path: '/personal/dealCenter'})
                    })
                });
            },
            //内销项目审批
            neixiaoshenpi(x) {
                if (x == '2') {
                    console.log("进来了");
                    //通

                    this.usercheck(x)
                } else {
                    //驳回
                    if (!this.formLabelAlign.checkMsg) {
                        this.$msg.msge("请填写审批意见");
                    } else {
                        this.usercheck(x)
                    }
                }
            },
            //采购项目审核
            caigoucheck(x) {
                this.formLabelAlign.taskid = this.$route.query.taskid;
                this.formLabelAlign.status = x;
                ss.ProService.checkCaigou(this.formLabelAlign).then(rd => {
                    this.$store.dispatch('searchTasktotal');
                    this.$msg.msgs(rd.msg);
                    this.$router.back();
                });
            },
            //采购项目审批
            caigoushenpi(x) {
                if (x == '2') {
                    this.caigoucheck(x)
                } else {
                    //驳回
                    if (!this.formLabelAlign.checkMsg) {
                        this.$msg.msge("请填写审批意见");
                    } else {
                        this.caigoucheck(x)
                    }
                }
            },
            cancelPro() {
                //点击返回关闭当前页
                // window.close();
                this.$router.go(-1);

            },
            //竞品使用
            selectC(item) {
                this.categorys = item;
                console.log(this.categorys)
            },
            delUserProduction1(index) {
                this.productInfosHaier.splice(index, 1)
                //console.log(index,"删除一行数据");
            },
            delUserProduction2(index) {
                this.productInfosOther.splice(index, 1)
                //console.log(index,"删除一行数据");
            },
            addComp() {
                var id = this.$util.getUuid();
                console.log(id, "----------------");
                var a = {id: id, type: 2, fromType: 1}
                console.log(a, "----------------");
                this.productInfosOther.push(a)
            },
            addHaier() {
                var id = this.$util.getUuid();
                var a = {id: id, type: 1, fromType: 1, specification: '', brand: "Haier"}
                this.productInfosHaier.push(a)
            },
            //大类修改时，当块数据proProduct[i]-v,index-i
            changeBigHaierBig(v, i) {
                //console.log("1选中大类",v);
                v.specification = '';
                //console.log("2选中大类v.productId222",v,i);
                this.selectProductHaier(v.category, i);
            },
            //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProductHaier(v, i) {
                //console.log("3选中大类222",v,i);
                ss.ProService.product2Select(v).then(rd => {
                    //console.log("4产品小类下拉", rd)
                    this.optionsProductHaier[i] = rd;
                    this.$set(this.optionsProductHaier, i, rd);
                    //console.log(this.optionsProductHaier[i],"5产品小类下拉", this.optionsProductHaier)
                })
            },
            selectProductBig() {
                ss.ProService.product1Select().then(rd => {
                    console.log("产品大类下拉", rd)
                    this.optionsProductBig = rd;
                })
            },
            // 关闭新手引导页
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i) {
                if (this.status == '1') {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            },
            getTenderList(value){
                var data = {
                    proName: null,
                }
                data.proName = value;
                ss.ProService.selectTender(data).then(rd => {
                    if(rd.f){
                        this.proList = rd.msg;
                    }
                })
            },
            getTenderDetailList(){
                this.proProduct = [];
                if(this.formLabelAlign.proId){
                    var data = {};
                    var supplierCode = null;
                    var supplierName = null;
                    for(var i = 0;i<this.proList.length;i++){
                        var tender = this.proList[i];
                        if(this.formLabelAlign.proId == tender.id){
                            supplierCode = tender.supplierCode;
                            supplierName = tender.supplierName;
                        }
                    }
                    data.id = this.formLabelAlign.proId;
                    ss.ProService.selectTenderDetail(data).then(rd => {
                        if(rd.f){
                            this.proDetailList = rd.msg;
                            for(var i = 0; i < this.proDetailList.length;i++){
                                var obj = this.proDetailList[i];
                                var data = {};
                                data.type = obj.levelcode;
                                data.typeName =  obj.levelname;
                                data.productName = obj.materialName;
                                data.productId = obj.materialCode;
                                data.productNum = obj.num;
                                data.productPrice = obj.price;
                                data.currency = obj.currency;
                                data.supplierCode = supplierCode;
                                data.supplierName = supplierName;
                                data.levelname = obj.levelname;
                                data.shuilv = obj.shuilv;
                                // data.optionsProductCg = null;
                                this.proProduct.push(data);
                            }
                        }
                        this.proProduct.forEach(obj =>{
                            this.changeBigCg(obj);
                            this.optionsProduct2Cg1(obj,obj.productName,obj.productId)
                        });
                    })
                }
            },
            optionsProduct2Cg1(v,a,b) {
                console.log(v,a,b)
                var optionsProductCg = null;
                ss.ProService.product2OemSelect(v.type).then(rd => {
                    optionsProductCg = rd;
                    if (optionsProductCg && optionsProductCg.length > 0) {
                        var abb = 0;
                        for (var i = 0; i < optionsProductCg.length; i++) {
                            if (a == optionsProductCg[i].levelname && b == optionsProductCg[i].id) {
                                v.productId = optionsProductCg[i].id
                                abb++;
                            }
                        }
                    }
                    if (abb == 1) {
                        v.xuniFlag = 0
                    } else {
                        v.xuniFlag = 1
                        v.productId = ''
                    }
                })
            },
        },

    }
</script>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
</style>

<style scoped>
    .Z-yuan {
        position: absolute;
        left: 90%;
    }

    .yuan {
        position: absolute;
        left: 85%;
    }

    .n-bu .h-formbLine .h-elformWrap-2,
    .n-j .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .pieceCon, .product {
        padding-top: 20px;
        border-radius: 4px;
        margin-left: 15px;
    }

    .ccc {
        margin-top: -13px;
    }

    .N-chan .h-pieceTitle2, .n-hu .h-pieceTitle2 {
        margin-bottom: 0.4rem;
        margin-left: 0;
    }

    .whetherTitle {
        margin-right: 20px;
    }

    .zhongT {
        margin-bottom: 20px;
        margin-left: -42px;
    }

    .Z-biao {
        margin-left: 76px;
    }

    .hetong {
        display: inline-block;
        margin-top: 13px;
    }

    .bigDiv {
        margin: 20px;
    }

    h6 {
        padding-left: 23px;
        color: #0e75e9;
        font-size: 15px;
    }

    .whether {
        font-size: 0.14rem;
        margin-left: 33px;
        padding-bottom: 20px;
    }

    .bbbb {
        padding-top: 5px;

    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    .bbbb .h-formbLine .el-form-item__label {
        width: 17%;
    }

    .j_one .el-range-editor.is-disabled .el-range-separator {
        margin-bottom: 19px;
    }

    .j_one .h-formbLine .el-form-item__label {
        width: 12.5%;
    }

    .j_one .h-formbLine .el-form-item__content {
        width: 77.5%;
    }

    .j_one .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 79.9%;
    }

    .zhongT .h-formbLine .el-form-item__content,
    .n-bu .h-formbLine .el-form-item__content,
    .n-j .h-formbLine .el-form-item__content {
        width: 57%;
    }

    .zhongT .h-formbLine .el-form-item__label,
    .n-bu .h-formbLine .el-form-item__label,
    .n-chan .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-bu .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 12%;
    }

    .n-bu .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 88%;
    }

    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }

    .categoryBox .category {
        width: 1.22rem;
        height: 0.36rem;
        color: #b0b0b0;
        font-size: 0.16rem;
        text-align: center;
        line-height: 0.34rem;
        margin-left: 0.2rem;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }

    .categoryBox .category:first-child {
        margin-left: 0;
    }

    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #1b78e6;
        background: #1b78e6;
    }

    .ljjtablepaddings8 .h-tableInput .el-input__inner {
        padding: 0.05rem 0.1rem;
    }

    .ljjtablepaddings8 .h-tableInput .el-input__icon {
        line-height: 0.25rem;
    }

    .weekplandetail2s .h-formbLine .el-form-item__label {
        width: 20%;
    }

    .weekplandetail2s .h-formbLine .el-form-item__content {
        width: 80%;
    }

    .ljjpdetailsdisabled.el-input.is-disabled .el-input__inner {
        border-color: transparent;
    }

    .ljjtablepaddings9 .h-tableInput .el-input__inner {
        padding: 0.05rem 0.1rem;
    }

    .ljjtablepaddings9 .h-tableInput .el-input__icon {
        line-height: 0.25rem;
    }
</style>
